import { Component, OnInit } from '@angular/core';
import { AuthService } from '../services/auth.service';
import firebase from 'firebase/compat/app';
import { Observable } from 'rxjs';
import { NgIf, AsyncPipe } from '@angular/common';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'app-user-summary',
  templateUrl: './user-summary.component.html',
  styleUrls: ['./user-summary.component.scss'],
  imports: [NgIf, MatButton, AsyncPipe],
})
export class UserSummaryComponent implements OnInit {
  authUser$!: Observable<firebase.User | null>;

  constructor(private readonly authService: AuthService) {
    this.authUser$ = this.authService.authUser$;
  }

  ngOnInit(): void {}

  logout() {
    this.authService.signOut();
  }

  get loggedInUser$() {
    return this.authService.authUser$;
  }
}
